import useTranslation from '@space-lib/hooks/useTranslation'

export const useI18n = () => {
  const { t } = useTranslation()

  return {
    search: t('emoji_picker.search'),
    search_no_results_1: t('emoji_picker.search_no_results_1'),
    search_no_results_2: t('emoji_picker.search_no_results_2'),
    pick: t('emoji_picker.pick'),
    add_custom: t('emoji_picker.add_custom'),
    categories: {
      activity: t('emoji_picker.categories.activity'),
      custom: t('emoji_picker.categories.custom'),
      flags: t('emoji_picker.categories.flags'),
      foods: t('emoji_picker.categories.foods'),
      frequent: t('emoji_picker.categories.frequent'),
      nature: t('emoji_picker.categories.nature'),
      objects: t('emoji_picker.categories.objects'),
      people: t('emoji_picker.categories.people'),
      places: t('emoji_picker.categories.places'),
      search: t('emoji_picker.categories.search'),
      symbols: t('emoji_picker.categories.symbols')
    },
    skins: {
      choose: t('emoji_picker.skins.choose'),
      1: t('emoji_picker.skins.1'),
      2: t('emoji_picker.skins.2'),
      3: t('emoji_picker.skins.3'),
      4: t('emoji_picker.skins.4'),
      5: t('emoji_picker.skins.5'),
      6: t('emoji_picker.skins.6')
    }
  }
}
